<template>
  <div>
    <!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'目标对阵用户'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <!-- 结果展示 -->
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>国科销售区域调整</h1>
                </div>
                <div class="h-pieceCon2" style="padding:0">
                <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                  <el-table
                      ref="multipleTable"
                      @selection-change="handleSelectionChange"
                      :data="tableData"
                      :border="true"
                      stripe
                      max-height="560"
                      style="width: 100%">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                    </el-table-column>
                    <el-table-column prop="sapCode" label="国科系统订单编号"width="180px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="soldToCode" label="售达方编码" width="90px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="soldToName" label="售达方名称" width="120px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="salesRegion" label="销售区域" width="140px" ></el-table-column>
                    <el-table-column prop="salesRegionNew" label="收入调减区域" width="140px" ></el-table-column>
                    <el-table-column prop="contactName" label="收货联系人" width="90px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="materialName" label="物料名称" width="150px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="materialCode" label="物料编码" width="120px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="currencyCode" label="币种编码" width="180px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="proNumber" label="产品数量" width="100px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="unitSellingPrice" label="不含税价格" width="110px"></el-table-column>
                    <el-table-column prop="unitPrice" label="含税价格" width="100px" :show-overflow-tooltip="true"></el-table-column>
                    <el-table-column prop="totalPrice" label="计算后的总金额" width="140px" ></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" width="140px" ></el-table-column>
                  </el-table>
                </div>
                <div class="bannerBox2">
                  <div class="h-row h-mrt1">
                    <div class="h-rowIn">
                      <div class="h-rowBox">
                        <div class="h-rowCon">
                          <div class="h-pieceIn2">
                            <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                            <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                              <h1>审核信息</h1>
                            </div>
                            <div class="h-pieceCon2 ">
                              <div class="h-formLine weekplandetail11" style="position: relative;">
                                <el-form :inline="true" :model="delData">
                                  <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                style="width: 100%!important;">
                                    <el-input
                                        v-model="delData.auditMind2"
                                        placeholder="请输入"></el-input>
                                  </el-form-item>
                                </el-form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="text-align: center;margin-top: 0.3rem">
                  <el-button class="h-btn h-bBtn h-bgwhite" @click="goBack"> 返回 </el-button>

                  <el-button class="h-btn h-bBtn h-bgred" @click="pass(2)">驳回</el-button>
                  <el-button class="h-btn h-bBtn h-bggreen" @click="pass(1)">通过</el-button>

                  <el-button class="h-btn h-bBtn" @click="viewpress">
                    审批跟踪
                  </el-button>
                </div>
                <viewhistory :visible.sync="showhistory" v-if="showhistory"
                             :id="instid"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import agentCopyService from "../../../api/loud/agent/agentCopyService";

export default {
  data() {
    return {
      q: {
        customerName: '',
        agentName: '',
        scenesName: '',
        areaName: '',
        pageNo: 1,
        pageSize: 10,
        total: 0,
        year: '',
      },
      delData: [],
      qyearList: [],
      quyuList: [],
      qudaoList: [],
      size: '',
      tableData: [],
      refid:null,
      //表格
      multipleSelection: [],
      // 展开折叠筛选
      isScreen: false,
      uploaddownexcelflag: false,
      daquflag:false,
      newDialog: false,
      editDialog: false,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      weekList: [],
      authTypeListEdit: [],
      disEdit: false,
      workList: [],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList: [],
      groupList: [],
      groupArr: [],
      titleDig: "",
      iscontract : '',//是否维护了合同

      shenglist: [],// 省份list
      cityList: [],      //城市list
      customerNameList: [], //用户单位list
      agentList: [],      //签约经销商
      showhistory:false,
      instid:"",
    }

  },

  methods: {

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectPageAll() {
      console.log("12312312312", this.q)
      ss.GKOrderPage.gkOrderList(this.q).then(rd=>{
        console.log(rd)
        console.log("total", rd.total)
        this.tableData = rd.records
        this.q.total = rd.total
      })
    },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    uploadExcelFilecallback(rd) {
      this.$msg.msgs(rd.msg);
      this.selectPageAll()
    },
    changeTop(val){
      console.log("changeTop",val);
    },
    pass(aaa){
      let query = {
        taskid:this.$route.query.taskid,
        aaa:aaa,
        instid:this.$route.query.instid,
        ywid:this.$route.query.ywid,
        list:this.tableData
      }
      ss.GKOrderPage.gkOrderPass(query).then(rd=>{
        this.$msg.alerts("提交成功！", () => {
          //刷新右上角的代办个数
          this.$store.dispatch("searchTasktotal")
          //跳转回系统的代办列表
          this.$router.push({
            path: '/personal/dealCenter'
          })
        })
      })
    },

    viewpress() {
      this.showhistory = true;
    },
    goBack() {
      this.$router.push({
        path: '/dingd/dingdListGK'
      })
    },
    loadArea(i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      }

      console.log(proSelect)
      ss.Dictservice.arealist(proSelect).then(rd => {
        this.shenglist = rd;
      })
    },
    // 省份选择器
    handleItemChange1(o, salesman, city) {
      if(o == ""){
        return
      }
      this.city = city;
      if (city == null) {
        this.city = null;
      }
      this.add.provinceList = _.find(this.shenglist, {code: o});
      ss.Dictservice.getCity({code: o}).then(rd => {
        this.cityList = rd.zlist;
      })
    },
    handleItemChange2(o) {
      this.add.city = o;
    },
    //获取用户单位
    showGroupList(value) {
      if(value == "" ){
        return;
      }
      ss.MuBiao.getUserLoud(value).then(res => {
        console.log(res)
        this.customerNameList = res
        this.add.customerCode = res[0].deptId
      })
    },
    getqWeeksBySelectYear() {
      this.getqWeeks(this.q.year, 1);
    },
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    exit() {
      this.closeDialog()
    },
    getQuyuList() {
      ss.Dictservice.listbycategory("YLRegion").then(rd => {
        this.quyuList = rd;
      })
    },
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
      })
    },
    getWeeks(y) {
      ss.MuBiao.getWeekList({year: y}).then(rd => {
        this.weekList = rd;
      })
    },
    getWeeksBySelectYear() {
      this.getWeeks(this.add.year);
      ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
        this.addlianqunList = rd;
      })
    },
    getListByInstid(instid) {
      console.log(instid)
      var query = {
        instid:instid,
      }
      ss.GKOrderPage.gkOrderList(query).then(rd=>{
        console.log(rd)
        this.tableData = rd.msg
      })
    },

  },
  watch: {
    'add.customerName': {
      deep: true,
      handler: function (newVal, oldVal) {
        this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
        var len = this.groupList.length;//groupList
        var arr = [];
        for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
          if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
            arr.push({
              value: this.groupList[i].name,
              id: this.groupList[i].id
            })
          }
        }
        this.groupArr = arr
      }
    },
  },
  created() {
      this.getListByInstid(this.$route.query.instid);
      this.instid = this.$route.query.instid;
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}


/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
</style>
